import React from 'react'

const currentYear = new Date().getFullYear();

function Footer() {
  return (
    <>
        <footer className="bg-dark pt-8 pt-md-9 position-relative" data-bs-theme="dark">

        <div className="container">
            <div className="row g-4 justify-content-between">
                
                <div className="col-lg-4">
                    
                    <a href="/">
					<img className="h-40px" src="assets/images/logo-white.png" alt="logo"/>
				</a>

        <p className="my-3 my-lg-4">Arix Automation delivers cutting-edge software solutions, digital marketing, and technology consulting to help businesses grow faster and smarter.</p>
                    
                    <ul className="list-inline mb-0">
                        <li className="list-inline-item"> <a className="btn btn-xs btn-icon btn-secondary" href="https://www.facebook.com/profile.php?id=61593436621403" target="_blank" rel="noreferrer"><i className="bi bi-facebook lh-base"></i></a> </li>
                        <li className="list-inline-item"> <a className="btn btn-xs btn-icon btn-secondary" href="https://www.instagram.com/arix.automation" target="_blank" rel="noreferrer"><i className="bi bi-instagram lh-base"></i></a> </li>
                        <li className="list-inline-item"> <a className="btn btn-xs btn-icon btn-secondary" href="#"><i className="bi bi-twitter-x lh-base"></i></a> </li>
                        <li className="list-inline-item"> <a className="btn btn-xs btn-icon btn-secondary" href="https://www.linkedin.com/company/arixautomation/posts/?feedView=all" target="_blank" rel="noreferrer"><i className="bi bi-linkedin lh-base"></i></a> </li>
                    </ul>
                </div>
                

                
                <div className="col-lg-6 col-xxl-4">
                    <div className="row g-4">
                        
                        <div className="col-6">
                            <h6 className="mb-3 mb-sm-4">Company</h6>
                            
                            <ul className="nav flex-column gap-1">
                                <li className="nav-item"><a className="nav-link pt-0" href="/about">About us</a></li>
                                <li className="nav-item"><a className="nav-link" href="/contact">Contact us</a></li>
                                <li className="nav-item"><a className="nav-link" href="/contact">Become a partner</a></li>
                                <li className="nav-item"><a className="nav-link" href="/services">Services</a></li>
                            </ul>
                        </div>

                    </div>
                </div>
                
            </div>

            
            <hr className="mt-xl-5 mb-0 opacity-1"/>

            
            <div className="d-md-flex justify-content-between align-items-center text-center text-lg-start py-4">
                
                <div className="text-body small mb-3 mb-md-0"> Copyrights ©{currentYear} Arix Automation. </div>

                
                <ul className="nav d-flex justify-content-center gap-1 mb-0">
                    <li className="nav-item"><a className="nav-link small py-0" href="#">Privacy policy</a></li>
                    <li className="nav-item"><a className="nav-link small py-0 pe-0" href="#">Terms & conditions</a></li>
                </ul>
            </div>
        </div>
    </footer>  
    </>
  )
}

export default Footer
